/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Status_Context_LengthInputs */

const en_admin_ai_chat_status_context_length = /** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This chat is too long. Start a new chat`)
};

const de_admin_ai_chat_status_context_length = /** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Chat ist zu lang. Starte einen neuen Chat`)
};

const es_admin_ai_chat_status_context_length = /** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este chat es demasiado largo. Empieza un chat nuevo`)
};

const fr_admin_ai_chat_status_context_length = /** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce chat est trop long. Commencez un nouveau chat`)
};

const nl_admin_ai_chat_status_context_length = /** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze chat is te lang. Start een nieuwe chat`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */
const it_admin_ai_chat_status_context_length = en_admin_ai_chat_status_context_length;

/** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_context_length = en_admin_ai_chat_status_context_length;

/** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */
const pl_admin_ai_chat_status_context_length = en_admin_ai_chat_status_context_length;

/** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */
const hu_admin_ai_chat_status_context_length = en_admin_ai_chat_status_context_length;

/** @type {(inputs: Admin_Ai_Chat_Status_Context_LengthInputs) => LocalizedString} */
const ro_admin_ai_chat_status_context_length = en_admin_ai_chat_status_context_length;

/**
* | output |
* | --- |
* | "This chat is too long. Start a new chat" |
*
* @param {Admin_Ai_Chat_Status_Context_LengthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_context_length = /** @type {((inputs?: Admin_Ai_Chat_Status_Context_LengthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_Context_LengthInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_context_length(inputs)
	if (locale === "de") return de_admin_ai_chat_status_context_length(inputs)
	if (locale === "es") return es_admin_ai_chat_status_context_length(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_context_length(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_context_length(inputs)
	if (locale === "it") return it_admin_ai_chat_status_context_length(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_context_length(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_context_length(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_context_length(inputs)
	return ro_admin_ai_chat_status_context_length(inputs)
});
export { admin_ai_chat_status_context_length as "admin.ai_chat.status_context_length" }